import { FC } from "react";
import Grid from "@material-ui/core/Grid";
import classNames from "classnames";
import { format } from "lib/globalize-util";
import _ from "lodash";
import * as React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import theme from "styles/theme";

interface IProps {
    errorList: string[];
}

export const UploadErrors: FC<IProps> = ({ errorList }) => {
    const classes = useStyles({});
    return _.isEmpty(errorList) ? null : (
        <Grid className={classes.root} container={true} wrap="wrap" direction="column">
            <Grid className={classNames(classes.margin, classes.errorHeader)} item={true} xs={true}>
                {format("We found the following errors with your upload:")}
            </Grid>
            {_.map(errorList, (error: string, index: number) => (
                <Grid key={`${error}_${index}`} className={classNames(classes.margin, classes.errorItem)} item={true}>
                    {error}
                </Grid>
            ))}
        </Grid>
    );
};

const useStyles = makeStyles({
    root: {
        margin: "8px 20px",
    },
    margin: {
        margin: "8px",
    },
    errorHeader: {
        fontSize: "14px",
    },
    errorItem: {
        fontSize: "14px",
        "&::before": {
            content: "'\\A'",
            display: "inline-block",
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: theme.palette.darkGrey,
            marginRight: "12px",
        },
    },
});
